// extracted by mini-css-extract-plugin
export default {"countTickets":"count-tickets_countTickets__c99lr","count":"count-tickets_count__f3bF4"};